/**
 * 이 사람이 그 능력을 갖고 있는가.
 *
 * **권한이 없는 자리는 그리지 않는다.** 그려 놓고 누르면 막는 방식은 두 가지를 잃는다 —
 * 화면은 할 수 없는 일로 채워지고, 사용자는 눌러 보고 나서야 자기 권한을 알게 된다.
 * 카드 한 장이 통째로 그 능력에 매여 있으면 카드째 빼고, 카드 안의 한 동작만 매여 있으면
 * 그 동작만 뺀다.
 *
 * **감추는 것은 편의이지 방어가 아니다.** 서버가 같은 능력을 다시 검사한다 — 주소를
 * 직접 치고 들어와도 결과는 같다.
 */
export function can(me: { capabilities: readonly string[] } | null, capability: string): boolean {
  return me?.capabilities.includes(capability) ?? false;
}

/**
 * 권한 이름 — 사람이 읽는 말.
 *
 * 시스템 화면의 "내 권한" 과 사용 설명서의 "이 메뉴는 ‘…’ 권한이 필요합니다" 가 같은 말을
 * 써야 한다. 한쪽은 "화면 변경", 다른 쪽은 "화면 관리" 라고 부르면 사용자는 두 권한이
 * 따로 있다고 읽는다.
 */
export const CAPABILITY_LABEL: Readonly<Record<string, string>> = {
  read: '조회',
  'content:write': '콘텐츠 변경',
  'schedule:write': '편성 변경',
  'fleet:write': '화면 변경',
  'emergency:write': '긴급 오버라이드',
  'report:read': '리포트 조회',
  'audit:read': '감사로그 조회',
  'user:manage': '사용자 관리',
  'settings:write': '환경 설정',
  // 시스템 역할(`system`)의 능력. 예전 이름은 `admin` — 고객사 관리자(역할 `admin`)는 갖지 않는다.
  system: '시스템',
  // 시스템 역할이 갖는다 — 외부 보관·알림 채널·스크립트 실행(정비 모드 ▸ 플러그인).
  'plugin:manage': '플러그인',
};

/**
 * 기능 표식(`feature:<모듈>`) — 권한이 아니라 서버가 `/me` 의 `features` 로 알려 주는 것(`nav.ts` 의
 * `navCapabilities`). 메뉴를 가리는 값이라, 설명서의 장 머리가 "왜 나한테는 이 메뉴가 없지" 에 답할 때 이 말을
 * 쓴다. `who` 는 "…에만 보입니다" 앞에 들어간다. 권한 칩 목록(시스템 화면)에는 넣지 않는다 — 역할이 갖는 것이 아니다.
 */
export const FEATURE_ACCESS: Readonly<Record<string, { label: string; who: string }>> = {
  'feature:hub': { label: '통합 관제', who: '통합 관제를 켠 서버에서 화면 변경 권한이 있고 담당 범위가 없는 계정' },
  'feature:hub_monitor': {
    label: '통합 모니터링',
    who: '통합 관제를 켜고 원격 서버를 등록한 서버에서 화면 변경 권한이 있고 담당 범위가 없는 계정',
  },
};
